import React, {useContext} from 'react';

const IntegratorContext = React.createContext();

export const useIntegratorContext = () => useContext(IntegratorContext);

export default IntegratorContext;
